// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".permission-container[data-v-67e6dfac] {\n  padding: 24px;\n}", ""]);
// Exports
module.exports = exports;
